export const WaveDivider = ({ flip = false, color = "#FAF4E1" }) => {
  return (
    <div className={`w-full overflow-hidden leading-none ${flip ? "rotate-180" : ""}`}>
      <svg
        viewBox="0 0 1440 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-16 md:h-24"
        preserveAspectRatio="none"
      >
        <path
          d="M0 20L48 25C96 30 192 40 288 45C384 50 480 50 576 45C672 40 768 30 864 30C960 30 1056 40 1152 45C1248 50 1344 50 1392 50L1440 50V100H1392C1344 100 1248 100 1152 100C1056 100 960 100 864 100C768 100 672 100 576 100C480 100 384 100 288 100C192 100 96 100 48 100H0V20Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export const WaveDividerAlt = ({ flip = false, color = "#E0FBFC" }) => {
  return (
    <div className={`w-full overflow-hidden leading-none ${flip ? "rotate-180" : ""}`}>
      <svg
        viewBox="0 0 1440 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-16 md:h-24"
        preserveAspectRatio="none"
      >
        <path
          d="M0 50L60 45C120 40 240 30 360 25C480 20 600 20 720 30C840 40 960 60 1080 65C1200 70 1320 60 1380 55L1440 50V100H1380C1320 100 1200 100 1080 100C960 100 840 100 720 100C600 100 480 100 360 100C240 100 120 100 60 100H0V50Z"
          fill={color}
        />
      </svg>
    </div>
  );
};
